(function () {
    var root = document.querySelector("#octulos-card-centering-checker");
    if (!root) return;

    var sides = {
      front: createSideState(),
      back: createSideState()
    };
    var activeSide = "front";

    var stage = root.querySelector("[data-stage]");
    var overlay = root.querySelector(".octulos-centering__overlay");
    var image = root.querySelector("[data-preview-image]");
    var imageInput = root.querySelector("[data-image-input]");
    var cameraInput = root.querySelector("[data-camera-input]");
    var uploadLabel = root.querySelector("[data-upload-label]");
    var cameraLabel = root.querySelector("[data-camera-label]");
    var resetButton = root.querySelector("[data-reset-side]");
    var meshToggle = root.querySelector("[data-mesh-toggle]");
    var tabButtons = root.querySelectorAll("[data-side-tab]");
    var sliders = root.querySelectorAll("[data-slider]");
    var outputs = root.querySelectorAll("[data-value]");

    var cardPoly = root.querySelector("[data-card-poly]");
    var artPoly = root.querySelector("[data-art-poly]");
    var horizontalScore = root.querySelector("[data-horizontal-score]");
    var horizontalDetail = root.querySelector("[data-horizontal-detail]");
    var verticalScore = root.querySelector("[data-vertical-score]");
    var verticalDetail = root.querySelector("[data-vertical-detail]");
    var sideGrade = root.querySelector("[data-side-grade]");
    var sideGradeDetail = root.querySelector("[data-side-grade-detail]");
    var overallScore = root.querySelector("[data-overall-score]");
    var overallLabel = root.querySelector("[data-overall-label]");
    var activeDrag = null;

    function createSideState() {
      return {
        imageUrl: "",
        tlX: 8,
        tlY: 6,
        trX: 92,
        trY: 6,
        brX: 92,
        brY: 94,
        blX: 8,
        blY: 94,
        meshEnabled: false,
        meshTopX: 0,
        meshTopY: 0,
        meshRightX: 0,
        meshRightY: 0,
        meshBottomX: 0,
        meshBottomY: 0,
        meshLeftX: 0,
        meshLeftY: 0,
        artLeft: 12,
        artRight: 88,
        artTop: 14,
        artBottom: 86
      };
    }

    function active() {
      return sides[activeSide];
    }

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, Number(value)));
    }

    function normalizeSide(side) {
      ["tlX", "tlY", "trX", "trY", "brX", "brY", "blX", "blY"].forEach(function (key) {
        side[key] = clamp(side[key], 0, 100);
      });

      ["meshTopX", "meshTopY", "meshRightX", "meshRightY", "meshBottomX", "meshBottomY", "meshLeftX", "meshLeftY"].forEach(function (key) {
        side[key] = clamp(side[key], -25, 25);
      });

      side.artLeft = clamp(side.artLeft, 0, 98);
      side.artRight = clamp(side.artRight, side.artLeft + 1, 100);
      side.artTop = clamp(side.artTop, 0, 98);
      side.artBottom = clamp(side.artBottom, side.artTop + 1, 100);
    }

    function setLine(name, attrs) {
      var lines = root.querySelectorAll("[data-line-" + name + "], [data-hit-line-" + name + "]");
      lines.forEach(function (line) {
        Object.keys(attrs).forEach(function (key) {
          line.setAttribute(key, attrs[key]);
        });
      });
    }

    function setPolyline(name, points) {
      setLine(name, { points: pointString(points) });
    }

    function point(side, key) {
      return {
        x: Number(side[key + "X"]),
        y: Number(side[key + "Y"])
      };
    }

    function pointString(points) {
      return points.map(function (p) {
        return p.x.toFixed(3) + "," + p.y.toFixed(3);
      }).join(" ");
    }

    function mix(a, b, t) {
      return {
        x: a.x + (b.x - a.x) * t,
        y: a.y + (b.y - a.y) * t
      };
    }

    function addPoint(a, b) {
      return {
        x: a.x + b.x,
        y: a.y + b.y
      };
    }

    function multiplyPoint(pointValue, factor) {
      return {
        x: pointValue.x * factor,
        y: pointValue.y * factor
      };
    }

    function meshOffset(side, key) {
      return {
        x: Number(side["mesh" + key + "X"] || 0),
        y: Number(side["mesh" + key + "Y"] || 0)
      };
    }

    function edgeMidpoint(side, key) {
      if (key === "Top") return mix(point(side, "tl"), point(side, "tr"), 0.5);
      if (key === "Right") return mix(point(side, "tr"), point(side, "br"), 0.5);
      if (key === "Bottom") return mix(point(side, "bl"), point(side, "br"), 0.5);
      return mix(point(side, "tl"), point(side, "bl"), 0.5);
    }

    function mapCardPoint(side, u, v) {
      var tl = point(side, "tl");
      var tr = point(side, "tr");
      var br = point(side, "br");
      var bl = point(side, "bl");
      var mapped = mix(mix(tl, tr, u), mix(bl, br, u), v);
      if (!side.meshEnabled) return mapped;

      var topWeight = (1 - v) * Math.sin(Math.PI * u);
      var rightWeight = u * Math.sin(Math.PI * v);
      var bottomWeight = v * Math.sin(Math.PI * u);
      var leftWeight = (1 - u) * Math.sin(Math.PI * v);
      mapped = addPoint(mapped, multiplyPoint(meshOffset(side, "Top"), topWeight));
      mapped = addPoint(mapped, multiplyPoint(meshOffset(side, "Right"), rightWeight));
      mapped = addPoint(mapped, multiplyPoint(meshOffset(side, "Bottom"), bottomWeight));
      mapped = addPoint(mapped, multiplyPoint(meshOffset(side, "Left"), leftWeight));
      return mapped;
    }

    function cornerGripPoint(side, key) {
      var positions = {
        tl: { u: 0.075, v: 0.075 },
        tr: { u: 0.925, v: 0.075 },
        br: { u: 0.925, v: 0.925 },
        bl: { u: 0.075, v: 0.925 }
      };
      var pos = positions[key] || positions.tl;
      return mapCardPoint(side, pos.u, pos.v);
    }

    function pointerToSvgPoint(event) {
      var rect = overlay.getBoundingClientRect();
      return {
        x: clamp((event.clientX - rect.left) / rect.width * 100, 0, 100),
        y: clamp((event.clientY - rect.top) / rect.height * 100, 0, 100)
      };
    }

    function inverseCardPoint(side, p) {
      var u = clamp(p.x / 100, 0, 1);
      var v = clamp(p.y / 100, 0, 1);
      var tl = point(side, "tl");
      var tr = point(side, "tr");
      var br = point(side, "br");
      var bl = point(side, "bl");

      for (var index = 0; index < 8; index += 1) {
        var mapped = mapCardPoint(side, u, v);
        var fx = mapped.x - p.x;
        var fy = mapped.y - p.y;
        var du = {
          x: (1 - v) * (tr.x - tl.x) + v * (br.x - bl.x),
          y: (1 - v) * (tr.y - tl.y) + v * (br.y - bl.y)
        };
        var dv = {
          x: (1 - u) * (bl.x - tl.x) + u * (br.x - tr.x),
          y: (1 - u) * (bl.y - tl.y) + u * (br.y - tr.y)
        };
        var det = du.x * dv.y - dv.x * du.y;
        if (Math.abs(det) < 0.0001) break;
        var stepU = (fx * dv.y - dv.x * fy) / det;
        var stepV = (du.x * fy - fx * du.y) / det;
        u = clamp(u - stepU, 0, 1);
        v = clamp(v - stepV, 0, 1);
      }

      return { u: u, v: v };
    }

    function moveDraggedLine(event) {
      if (!activeDrag) return;
      event.preventDefault();
      var side = active();
      var p = pointerToSvgPoint(event);

      if (activeDrag.type === "corner") {
        side[activeDrag.key + "X"] = activeDrag.startX + p.x - activeDrag.startPoint.x;
        side[activeDrag.key + "Y"] = activeDrag.startY + p.y - activeDrag.startPoint.y;
      } else if (activeDrag.type === "mesh") {
        var base = edgeMidpoint(side, activeDrag.key);
        side["mesh" + activeDrag.key + "X"] = p.x - base.x;
        side["mesh" + activeDrag.key + "Y"] = p.y - base.y;
      } else if (activeDrag.type === "line") {
        var normalized = inverseCardPoint(side, p);
        if (activeDrag.key === "artLeft" || activeDrag.key === "artRight") {
          side[activeDrag.key] = normalized.u * 100;
        } else {
          side[activeDrag.key] = normalized.v * 100;
        }
      }

      render();
    }

    function fmt(value) {
      return Number(value).toFixed(1).replace(".", ",") + "%";
    }

    function ratioText(first, second) {
      return Math.round(first) + "/" + Math.round(second);
    }

    function measureHorizontal(side) {
      var left = Math.max(0, side.artLeft);
      var right = Math.max(0, 100 - side.artRight);
      var total = left + right;
      if (total <= 0) return null;
      var leftShare = left / total * 100;
      return {
        a: leftShare,
        b: 100 - leftShare,
        detail: "L " + fmt(left) + " / R " + fmt(right)
      };
    }

    function measureVertical(side) {
      var top = Math.max(0, side.artTop);
      var bottom = Math.max(0, 100 - side.artBottom);
      var total = top + bottom;
      if (total <= 0) return null;
      var topShare = top / total * 100;
      return {
        a: topShare,
        b: 100 - topShare,
        detail: "B " + fmt(top) + " / O " + fmt(bottom)
      };
    }

    function gradeFromMeasurements(horizontal, vertical) {
      if (!horizontal || !vertical) {
        return { label: "-", detail: "Meetlijnen ontbreken", maxOff: 100 };
      }
      var maxOff = Math.max(
        Math.abs(horizontal.a - 50),
        Math.abs(vertical.a - 50)
      );
      if (maxOff <= 5) return { label: "Sterk", detail: "Binnen 55/45", maxOff: maxOff };
      if (maxOff <= 10) return { label: "Goed", detail: "Binnen 60/40", maxOff: maxOff };
      if (maxOff <= 15) return { label: "Off-center", detail: "Binnen 65/35", maxOff: maxOff };
      return { label: "Zwak", detail: "Buiten 65/35", maxOff: maxOff };
    }

    function gradeRank(label) {
      if (label === "Sterk") return 1;
      if (label === "Goed") return 2;
      if (label === "Off-center") return 3;
      if (label === "Zwak") return 4;
      return 5;
    }

    function renderOverall() {
      var grades = ["front", "back"].map(function (sideName) {
        var side = sides[sideName];
        if (!side.imageUrl) return null;
        return gradeFromMeasurements(measureHorizontal(side), measureVertical(side));
      }).filter(Boolean);

      if (!grades.length) {
        overallLabel.textContent = "Klaar";
        overallScore.textContent = "-";
        return;
      }

      grades.sort(function (a, b) {
        return gradeRank(a.label) - gradeRank(b.label);
      });
      var worst = grades[grades.length - 1];
      overallLabel.textContent = grades.length === 2 ? "Voor en achter" : (activeSide === "front" ? "Voorkant" : "Achterkant");
      overallScore.textContent = worst.label;
    }

    function render() {
      var side = active();
      normalizeSide(side);
      root.classList.toggle("is-mesh-active", Boolean(side.meshEnabled));
      if (meshToggle) meshToggle.setAttribute("aria-checked", side.meshEnabled ? "true" : "false");

      if (side.imageUrl) {
        stage.classList.add("has-image");
        image.src = side.imageUrl;
      } else {
        stage.classList.remove("has-image");
        image.removeAttribute("src");
      }

      var tl = point(side, "tl");
      var tr = point(side, "tr");
      var br = point(side, "br");
      var bl = point(side, "bl");
      var artLeft = side.artLeft / 100;
      var artRight = side.artRight / 100;
      var artTop = side.artTop / 100;
      var artBottom = side.artBottom / 100;
      var artTl = mapCardPoint(side, artLeft, artTop);
      var artTr = mapCardPoint(side, artRight, artTop);
      var artBr = mapCardPoint(side, artRight, artBottom);
      var artBl = mapCardPoint(side, artLeft, artBottom);

      cardPoly.setAttribute("points", pointString([tl, tr, br, bl]));
      artPoly.setAttribute("points", pointString([artTl, artTr, artBr, artBl]));

      setPolyline("card-left", [tl, mapCardPoint(side, 0, 0.5), bl]);
      setPolyline("card-right", [tr, mapCardPoint(side, 1, 0.5), br]);
      setPolyline("card-top", [tl, mapCardPoint(side, 0.5, 0), tr]);
      setPolyline("card-bottom", [bl, mapCardPoint(side, 0.5, 1), br]);
      setPolyline("art-left", [mapCardPoint(side, artLeft, 0), mapCardPoint(side, artLeft, 0.5), mapCardPoint(side, artLeft, 1)]);
      setPolyline("art-right", [mapCardPoint(side, artRight, 0), mapCardPoint(side, artRight, 0.5), mapCardPoint(side, artRight, 1)]);
      setPolyline("art-top", [mapCardPoint(side, 0, artTop), mapCardPoint(side, 0.5, artTop), mapCardPoint(side, 1, artTop)]);
      setPolyline("art-bottom", [mapCardPoint(side, 0, artBottom), mapCardPoint(side, 0.5, artBottom), mapCardPoint(side, 1, artBottom)]);

      root.querySelectorAll("[data-drag-corner]").forEach(function (handle) {
        var key = handle.getAttribute("data-drag-corner");
        var grip = cornerGripPoint(side, key);
        handle.style.left = grip.x + "%";
        handle.style.top = grip.y + "%";
      });
      root.querySelectorAll("[data-drag-mesh]").forEach(function (handle) {
        var key = handle.getAttribute("data-drag-mesh") || "";
        var label = key.slice(0, 1).toUpperCase() + key.slice(1);
        var p = addPoint(edgeMidpoint(side, label), meshOffset(side, label));
        handle.setAttribute("cx", p.x);
        handle.setAttribute("cy", p.y);
      });

      sliders.forEach(function (slider) {
        var key = slider.getAttribute("data-slider");
        slider.value = side[key];
      });
      outputs.forEach(function (output) {
        var key = output.getAttribute("data-value");
        output.textContent = fmt(side[key]);
      });

      var horizontal = measureHorizontal(side);
      var vertical = measureVertical(side);
      var grade = gradeFromMeasurements(horizontal, vertical);

      horizontalScore.textContent = horizontal ? ratioText(horizontal.a, horizontal.b) : "-";
      horizontalDetail.textContent = horizontal ? horizontal.detail : "-";
      verticalScore.textContent = vertical ? ratioText(vertical.a, vertical.b) : "-";
      verticalDetail.textContent = vertical ? vertical.detail : "-";
      sideGrade.textContent = grade.label;
      sideGradeDetail.textContent = grade.detail;
      uploadLabel.textContent = side.imageUrl ? "Foto vervangen" : "Foto kiezen";
      if (cameraLabel) cameraLabel.textContent = side.imageUrl ? "Nieuwe foto maken" : "Foto maken";
      renderOverall();
    }

    tabButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        activeSide = button.getAttribute("data-side-tab");
        tabButtons.forEach(function (tab) {
          tab.classList.toggle("is-active", tab === button);
        });
        imageInput.value = "";
        if (cameraInput) cameraInput.value = "";
        render();
      });
    });

    sliders.forEach(function (slider) {
      slider.addEventListener("input", function () {
        var key = slider.getAttribute("data-slider");
        active()[key] = Number(slider.value);
        render();
      });
    });

    if (meshToggle) {
      meshToggle.addEventListener("click", function () {
        active().meshEnabled = !active().meshEnabled;
        render();
      });
    }

    root.querySelectorAll("[data-drag-line]").forEach(function (line) {
      line.addEventListener("pointerdown", function (event) {
        var key = line.getAttribute("data-drag-line") || "";
        if (!key) return;
        activeDrag = { type: "line", key: key };
        event.preventDefault();
        if (line.setPointerCapture) line.setPointerCapture(event.pointerId);
        moveDraggedLine(event);
      });
    });

    root.querySelectorAll("[data-drag-corner]").forEach(function (handle) {
      handle.addEventListener("pointerdown", function (event) {
        var key = handle.getAttribute("data-drag-corner") || "";
        if (!key) return;
        var p = pointerToSvgPoint(event);
        var side = active();
        activeDrag = {
          type: "corner",
          key: key,
          startPoint: p,
          startX: Number(side[key + "X"]),
          startY: Number(side[key + "Y"])
        };
        event.preventDefault();
        if (handle.setPointerCapture) handle.setPointerCapture(event.pointerId);
        moveDraggedLine(event);
      });
    });

    root.querySelectorAll("[data-drag-mesh]").forEach(function (handle) {
      handle.addEventListener("pointerdown", function (event) {
        var key = handle.getAttribute("data-drag-mesh") || "";
        if (!key) return;
        active().meshEnabled = true;
        activeDrag = { type: "mesh", key: key.slice(0, 1).toUpperCase() + key.slice(1) };
        event.preventDefault();
        if (handle.setPointerCapture) handle.setPointerCapture(event.pointerId);
        moveDraggedLine(event);
      });
    });

    window.addEventListener("pointermove", moveDraggedLine);
    window.addEventListener("pointerup", function () {
      activeDrag = null;
    });
    window.addEventListener("pointercancel", function () {
      activeDrag = null;
    });

    function useSelectedImage(input) {
      var file = input.files && input.files[0];
      if (!file) return;
      if (active().imageUrl) URL.revokeObjectURL(active().imageUrl);
      active().imageUrl = URL.createObjectURL(file);
      render();
    }

    imageInput.addEventListener("change", function () {
      useSelectedImage(imageInput);
    });

    if (cameraInput) {
      cameraInput.addEventListener("change", function () {
        useSelectedImage(cameraInput);
      });
    }

    resetButton.addEventListener("click", function () {
      var imageUrl = active().imageUrl;
      sides[activeSide] = createSideState();
      sides[activeSide].imageUrl = imageUrl;
      render();
    });

    render();
  })();
